import React, { Component } from 'react'
import RoleForm from '../_Components/RoleForm'
import ArchiveModal from '../_Components/ArchiveModal'
import TelehealthAccessCard from '../_Components/TelehealthAccessCard'

import { connect } from 'react-redux'
import { abilities } from '../../../../_constants/abilities.constants'
import { alertActions } from '../../../../_actions/alert.actions'
import { rolesService } from '../../../../_services/roles.service'
import { Row, Col, Button, Spinner } from 'react-bootstrap'

class EditRole extends Component {
  constructor(props) {
    super(props);

    this.state = {
      role: '',
      form: [],
      users: [],
      errors: [],
      events: [],
      library: [],
      billing: [],
      messages: [],
      roles: [],
      userCount: null,
      updating: false,
      locations: [],
      archiving: false,
      telehealth: [],
      description: '',
      showArchiveModal: false,
      showTelehealthAccessCard: false
    }

    this.id = this.props.match.params.id

    this.handleSave = this.handleSave.bind(this)
    this.handleBack = this.handleBack.bind(this)
    this.handleSetState = this.handleSetState.bind(this)
  }

  componentDidMount() {
    rolesService.retrieveRole(this.id)
      .then(response => {
        const data = response.data.data
        let role = {
          ...this.state,
          id: data.id,
          role: data.name,
          description: data.title,
          userCount: data.userCount
        }

        data.permissions.forEach((permission) => {
          const name = permission.name.split('-')[0]

          role[name].push(permission.name)
        })

      this.setState(role)
    })
    .catch((error) => {
      this.props.history.push('/account/roles')
      if (error.response && error.response.status === 404) {
        this.props.dispatch(alertActions.error(error.response.data.message));
      } else {
        this.props.dispatch(alertActions.error('Could not retrieve roles at this time. Please try again.'));
      }
    })
  }

  handleSetState(value) {
    this.setState(value)
  }

  handleBack() {
    this.props.history.push('/account/roles')
  }

  handleSave() {
    this.props.dispatch(alertActions.clear());

    let errors = {}

    if (this.state.role === '') {
      errors.role = 'Please enter a role name.'
    }
    if (this.state.description === '') {
      errors.description = 'Please enter a description.'
    }
   if (
      this.state.form.length === 0 &&
      this.state.users.length === 0 &&
      this.state.roles.length === 0 &&
      this.state.events.length === 0 &&
      this.state.library.length === 0 &&
      this.state.billing.length === 0 &&
      this.state.messages.length === 0 &&
      this.state.locations.length === 0 &&
      this.state.telehealth.length === 0 
   ) {
    errors.permissions = false;

    window.scroll(0,0)

    this.props.dispatch(alertActions.error('At least one permission must be selected for a role.'));
   }

    this.setState({errors: errors})

    if (Object.values(errors).length === 0) {
      this.setState({updating: true})
      const role = this.handleCreateRoleObject()

      rolesService.updateRole(role, this.id)
        .then(() => {
          this.props.history.push('/account/roles')
          this.props.dispatch(alertActions.success('Role successfully updated!'));
        })
        .catch((error) => {
          this.setState({updating: false})

          window.scroll(0,0)
          if (error.response && error.response.data && error.response.data.message) {
            this.props.dispatch(alertActions.error(error.response.data.message));
          } else {
            this.props.dispatch(alertActions.error('Could not update role at this time. Please try again.'));
          }
        })
    }
  }

  handleCreateRoleObject = () => {
    const role = {
      name: this.state.role,
      title: this.state.description
    }
    
    abilities.forEach((ability) => {
      const name = ability.split('-')[0]

      role[ability] = this.state[name].includes(ability)
    })
    return role
  }

  render() {
    const { errors, archiving, updating, showArchiveModal, showTelehealthAccessCard } = this.state

    if (!this.state.role) {
      return <Spinner animation='border' />
    }

    const userCountLabel = this.state.userCount === 1 ? 'User' : 'Users';
    const colorClass = this.state.userCount > 0 ? 'badge-info' : 'badge-warning';

    return (
      <>
        <ArchiveModal 
          id={this.id}
          count={this.state.userCount}
          show={showArchiveModal} 
          handleClose={() => this.setState({showArchiveModal: false})}
        />

        <header className='mb-4'>
          <Row>
            <Col lg='9' xl='7'>
              <div className='d-flex flex-row justify-content-between'>
                <div className='lead pt-2'>Edit Role</div>
                <span className={`badge badge-pill my-auto ${colorClass}`}>{`${this.state.userCount} ${userCountLabel}`}</span>
              </div>
            </Col>
          </Row>
        </header>

        <Row>
          <Col lg='9' xl='7'>
            <RoleForm 
              state={this.state}
              errors={errors}
              setState={this.handleSetState}
            >
              <Row className='mt-4 pt-3 px-3'>
                <Col xs='3'>
                  { 
                    this.state.role !== 'full-access' &&
                      <Button disabled={archiving || updating} onClick={() => this.setState({showArchiveModal: true})} block variant='danger'>
                        Archive Role
                      </Button>
                  }
                </Col>
                <Col xs={{span: 2, offset: 4}}>
                  <Button disabled={archiving || updating} onClick={this.handleBack} block variant='outline-secondary'>Cancel</Button>
                </Col>
                <Col xs='3'>
                  <Button disabled={archiving || updating} onClick={this.handleSave} block variant='success'>
                    { updating ? <Spinner size='sm' animation='border'/> : 'Save Role' }
                  </Button>
                </Col>
              </Row>
            </RoleForm>
          </Col>
          <Col xs='4'>
            { showTelehealthAccessCard && 
              <TelehealthAccessCard handleClose={() => this.setState({showTelehealthAccessCard: false})}/> }
          </Col>
        </Row>
      </>
    )
  }
}

export default connect()(EditRole);
